import Section from './Section';

export default class SectionFederationEmployeeRelation {

    static fromData(data) {
        if (!data) {
            return;
        }

        let relation = new SectionFederationEmployeeRelation();
        relation.id = data.id;
        relation.section = Section.fromData(data.section.data);

        Object.seal(relation);
        return relation;
    }

    toData() {
        return {
            id: this.id,
            section: this.section,
        };
    }

    isEmpty() {
        return !this.section;
    }
}
